import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getLiveProgress } from 'helpers/Live';
import style from './ProgressBar.module.scss';

const ProgressBar = ({ endDate, isContinueWatching, percentWatched, startDate, theme = {} }) => {
  const [liveProgress, setLiveProgress] = useState(null);
  const [liveInterval, setLiveInterval] = useState(null);
  useEffect(() => {
    function updateLiveProgress() {
      const newLiveProgress = getLiveProgress({ startDate, endDate });
      setLiveProgress(newLiveProgress);
      const programEnded = !newLiveProgress || (newLiveProgress && newLiveProgress >= 100);
      const shouldClearInterval = liveInterval && programEnded;
      if (shouldClearInterval) {
        clearInterval(liveInterval);
        setLiveInterval(null);
      }
    }
    if (!percentWatched) {
      const liveProgress = getLiveProgress({ startDate, endDate });
      if (liveProgress && liveProgress < 100) {
        const liveInterval = setInterval(() => {
          updateLiveProgress();
        }, 60000);
        setLiveInterval(liveInterval);
        setLiveProgress(liveProgress);
      }
    }
    return () => {
      clearInterval(liveInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(
    () => () => {
      clearInterval(liveInterval);
    },
    [liveInterval],
  );
  const percentWatchedUsed = percentWatched && percentWatched > 90 ? 100 : percentWatched;
  const progress = percentWatchedUsed || liveProgress;
  if (!progress && progress !== 0 && !isContinueWatching) return null;
  const progressClassSuffix = progress - (progress % 5);
  return (
    <div
      data-test="progress-bar"
      className={classNames(style.progress, theme.progress, `progress-${progressClassSuffix}`)}
    >
      <div
        className={classNames(
          style.done,
          theme.done,
          isContinueWatching && theme.doneContinueWatching,
          `done-${progressClassSuffix}`,
        )}
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

ProgressBar.propTypes = {
  endDate: PropTypes.string,
  isContinueWatching: PropTypes.bool,
  percentWatched: PropTypes.number,
  startDate: PropTypes.string,
  theme: PropTypes.shape({}),
};

export default ProgressBar;
